var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 16.5,
    height: 16.5,
    rx: 8.25,
    stroke: "white",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7063 8.78668H9.46224V5.54263C9.46224 5.39923 9.40528 5.26171 9.30388 5.16031C9.20248 5.05892 9.06496 5.00195 8.92157 5.00195C8.77817 5.00195 8.64065 5.05892 8.53925 5.16031C8.43786 5.26171 8.3809 5.39923 8.3809 5.54263V8.78668H5.13686C4.99347 8.78668 4.85595 8.84364 4.75455 8.94504C4.65316 9.04643 4.59619 9.18396 4.59619 9.32735C4.59619 9.47075 4.65316 9.60827 4.75455 9.70967C4.85595 9.81106 4.99347 9.86803 5.13686 9.86803H8.3809V13.1121C8.3809 13.2555 8.43786 13.393 8.53925 13.4944C8.64065 13.5958 8.77817 13.6528 8.92157 13.6528C9.06496 13.6528 9.20248 13.5958 9.30388 13.4944C9.40528 13.393 9.46224 13.2555 9.46224 13.1121V9.86803H12.7063C12.8497 9.86803 12.9872 9.81106 13.0886 9.70967C13.19 9.60827 13.2469 9.47075 13.2469 9.32735C13.2469 9.18396 13.19 9.04643 13.0886 8.94504C12.9872 8.84364 12.8497 8.78668 12.7063 8.78668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.2d4fb5ccf5ee9743aa61997051476c7f.svg";
export { ForwardRef as ReactComponent };